/**
 * Product Content JavaScript
 * Handles Brightcove video integration for product content tabs
 */

document.addEventListener('DOMContentLoaded', function () {
  // Get video IDs from the page data
  var videoIdsElement = document.querySelector('#product-content-data[data-video-ids]');
  if (!videoIdsElement) {
    return;
  }

  var videoIdsString = videoIdsElement.getAttribute('data-video-ids');
  if (!videoIdsString) {
    return;
  }

  var videoIds = videoIdsString.split(',').map(function(item) {
    return item.trim();
  }).filter(function(item) {
    return !!item;
  });

  if (!videoIds.length) {
    return;
  }

  // Fonction pour récupérer les détails des vidéos via Brightcove
  function fetchVideoDetails(refId) {
    var videoRef = 'ref:' + refId + '_1';
    var apiUrl = 'https://edge.api.brightcove.com/playback/v1/accounts/3415345270001/videos/' + videoRef;

    return fetch(apiUrl, {
      headers: {
        'Accept': 'application/json;pk=BCpkADawqM25tK5k0wXAEvRmx2OuqvN83QaVsRns-K8PtQq8_nnsmrez0J-XCVDOca82z0CHB2EpIqHdzZ3fyDJr8F9mBhyxsp3chevq5m3uhNH_BQ6wfHpXHZc3wgwy4DSXhwiTVKuFrIPd'
      }
    }).then(function(res) {
      if (!res.ok) {
        console.error('Brightcove API error for video ' + refId + ':', res.status);
        return null;
      }
      return res.json();
    }).catch(function(error) {
      console.error('Error fetching video details:', error);
      return null;
    });
  }

  // Récupérer et afficher les vidéos
  Promise.all(videoIds.map(fetchVideoDetails)).then(function(videoDetailsArray) {
    var videoContainerMobile = document.getElementById('video-container-mobile');
    var videoContainerDesktop = document.getElementById('video-container-desktop');

    videoDetailsArray.forEach(function(videoDetails, index) {
      if (!videoDetails) {
        console.warn('No details found for video ID ' + videoIds[index]);
        return;
      }

      // Création du lecteur vidéo pour mobile
      if (videoContainerMobile) {
        var videoElementMobile = document.createElement('video');
        videoElementMobile.setAttribute('id', 'video-mobile-' + videoDetails.id);
        videoElementMobile.setAttribute('data-video-id', videoDetails.id);
        videoElementMobile.setAttribute('data-account', '3415345270001');
        videoElementMobile.setAttribute('data-player', 'jQMS54WMw_default');
        videoElementMobile.setAttribute('data-embed', 'default');
        videoElementMobile.setAttribute('class', 'video-js');
        videoElementMobile.setAttribute('controls', '');
        videoElementMobile.setAttribute('data-setup', JSON.stringify({
          controls: true,
          preload: 'auto',
          techOrder: ['html5'],
          textTrackSettings: {
            manualCleanup: true
          }
        }));

        // Ajouter le poster si disponible
        if (videoDetails.poster) {
          videoElementMobile.setAttribute('poster', videoDetails.poster);
        }

        videoContainerMobile.appendChild(videoElementMobile);
      }

      // Création du lecteur vidéo pour desktop
      if (videoContainerDesktop) {
        var videoElementDesktop = document.createElement('video');
        videoElementDesktop.setAttribute('id', 'video-desktop-' + videoDetails.id);
        videoElementDesktop.setAttribute('data-video-id', videoDetails.id);
        videoElementDesktop.setAttribute('data-account', '3415345270001');
        videoElementDesktop.setAttribute('data-player', 'jQMS54WMw_default');
        videoElementDesktop.setAttribute('data-embed', 'default');
        videoElementDesktop.setAttribute('class', 'video-js');
        videoElementDesktop.setAttribute('controls', '');
        videoElementDesktop.setAttribute('data-setup', JSON.stringify({
          controls: true,
          preload: 'auto',
          techOrder: ['html5'],
          textTrackSettings: {
            manualCleanup: true
          }
        }));

        // Ajouter le poster si disponible
        if (videoDetails.poster) {
          videoElementDesktop.setAttribute('poster', videoDetails.poster);
        }

        videoContainerDesktop.appendChild(videoElementDesktop);
      }
    });

    // Initialisation Brightcove
    if (window.bc) {
      var videoElements = document.querySelectorAll('.video-js');
      videoElements.forEach(function(videoEl) {
        window.bc(videoEl);
      });
    } else {
      console.error('Brightcove player script is not loaded.');
    }
  });
});
